import { Link } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import React from "react";
import { useNavigate } from "react-router-dom";
import { CustomDataGrid } from "../../SharedComponents/CustomDataGrid/CustomDataGrid";

const PartnerTable = (props: any) => {
  const navigate = useNavigate();
  const showNoData = () => {
    const rootStyle = {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "200px"
    };
    return <div style={rootStyle}>{`Partner details are not available for ${props.tenantName} .`} </div>;
  };

  const columns: GridColDef[] = [
    {
      headerName: "Partner OneID",
      field: "partnerOneId",
      width: 160,
      sortable: true,
      renderCell: (params) => (
        <Link
          sx={{
            color: "rgb(0, 120, 212)",
            cursor: "pointer"
          }}
          underline="hover"
          onClick={() => {
            navigate(`/partners?partnerOneId=${encodeURIComponent(params.row.partnerOneId ?? "")}&mpnId=AllUp`);
          }}
        >
          {params.row.partnerOneId}
        </Link>
      )
    },
    {
      headerName: "Partner OneName",
      field: "partnerOneName",
      width: 180,
      sortable: true
    },
    {
      headerName: "Partner ID",
      field: "partnerId",
      width: 180,
      sortable: true,
      renderCell: (params) => (
        <Link
          sx={{
            color: "rgb(0, 120, 212)",
            cursor: "pointer"
          }}
          underline="hover"
          onClick={() => {
            navigate(`/partners?partnerOneId=${encodeURIComponent(params.row.partnerOneId ?? "")}&mpnId=${encodeURIComponent(params.row.partnerId ?? "")}`);
          }}
        >
          {params.row.partnerId}
        </Link>
      )
    },
    {
      headerName: "Partner Name",
      field: "partnerName",
      width: 180,
      sortable: true
    },
    {
      headerName: "Workload Name",
      field: "workloadName",
      width: 200,
      sortable: true
    },
    {
      headerName: "Partner Type",
      field: "partnerType",
      width: 100,
      sortable: true
    },
    {
      headerName: "Partner Country",
      field: "partnerCountry",
      width: 180,
      sortable: true
    },
    {
      headerName: "IsElite",
      field: "isElite",
      width: 100,
      sortable: true,
      type: "boolean"
    },
    {
      headerName: "IsSSTPartner",
      field: "isSSTPartner",
      width: 130,
      sortable: true,
      type: "boolean"
    },
    {
      headerName: "Partner Role",
      field: "partnerRole",
      width: 130,
      sortable: true,
      flex: 1
    }
  ];

  React.useEffect(() => {
    setTimeout(() => {
      const elements = document.getElementsByClassName("MuiDataGrid-virtualScroller");
      Array.from(elements).forEach(function (element) {
        element.setAttribute("tabIndex", "0");
      });
    }, 1000);
  }, []);
  return (
    <>
      {props.tableData && props.tableData.length > 0 ? (
        <div style={{ height: 600, width: "100%" }} tabIndex={0}>
          <CustomDataGrid
            columns={columns}
            enableUrlParams
            kustoLink={props.kustoLink}
            TabName={`Customer View - Partner Table for ${props.tenantName}`}
            exportCsvButtonProps={{
              fileNamePrefix: "partner-details"
            }}
            getRowId={(row) => row.id}
            rows={{ values: props.tableData ?? [], count: props.tableData?.length ?? 0 }}
          />
        </div>
      ) : (
        showNoData() || ""
      )}
    </>
  );
};

export default PartnerTable;
